import React from 'react'
import { Box } from '@mui/material'
import { keyframes } from '@mui/material/styles'

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
`

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
`

interface AnimatedSquaresProps {
  themeColors: {
    primary: string
    secondary: string
    light: string
    icon: React.ReactElement
    gradients: string[]
  }
}

const AnimatedSquares: React.FC<AnimatedSquaresProps> = ({ themeColors }) => {
  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'block' },
        position: 'absolute',
        right: '48px',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '280px',
        height: '280px',
      }}
    >
      {/* Animated squares */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          borderRadius: '32px',
          background: themeColors.gradients[0],
          animation: `${pulse} 4s ease-in-out infinite`,
          transform: 'rotate(0deg)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: '20px',
          borderRadius: '28px',
          background: themeColors.gradients[1],
          animation: `${pulse} 4s ease-in-out infinite 0.5s`,
          transform: 'rotate(10deg)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: '40px',
          borderRadius: '24px',
          background: themeColors.gradients[2],
          animation: `${pulse} 4s ease-in-out infinite 1s`,
          transform: 'rotate(20deg)',
        }}
      />
      {/* Center pattern */}
      <Box
        sx={{
          position: 'absolute',
          inset: '80px',
          borderRadius: '20px',
          background: themeColors.gradients[3],
          boxShadow: `0 20px 60px ${themeColors.light}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: `${float} 6s ease-in-out infinite`,
          transform: 'rotate(45deg)',
        }}
      >
        <Box
          sx={{
            // transform: 'rotate(-45deg)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& svg': {
              width: '64px',
              height: '64px',
              fontSize: 64,
              color: '#ffffff',
              opacity: 0.9,
              fill: '#ffffff',
              '& path': {
                fill: '#ffffff',
              },
            },
          }}
        >
          {themeColors.icon}
        </Box>
      </Box>
    </Box>
  )
}

export default AnimatedSquares
